import { useEffect, useState } from "react";
import {
  Lazy,
  lazyCat,
  lazySelected,
  lazySelectedCat,
  Active,
  activeCat,
  activeSelected,
  activeSelectedCat,
  VeryActive,
  veryActiveCat,
  veryActiveSelected,
  veryActiveSelectedCat,
  Thin,
  ThinCat,
  thinSelected,
  thinSelectedCat,
  Normal,
  NormalCat,
  normalSelected,
  normalSelectedCat,
  Fat,
  FatCat,
  fatSelected,
  fatSelectedCat
} from "../../assets/svg";
import { useTranslation } from "react-i18next";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function PetBodyInfo({ petInfo, setPetInfo, setIsComplete, petType }) {
  const [petKg, setPetKg] = useState(0);
  const [petGr, setPetGr] = useState(0);
  const [activityLevel, setActivityLevel] = useState();
  const [bodyType, setBodyType] = useState();
  const [activator, setActivator] = useState(false);

  const { t } = useTranslation();

  const petActivity = [
    {
      id: 1,
      title: t("sedentary"),
      value: "lazy",
      svg: petType === 'dog' ? Lazy : lazyCat,
      desc: t("basicNeeds"),
      selectedSvg: petType === 'dog' ? lazySelected : lazySelectedCat,
    },
    {
      id: 2,
      title: t("active"),
      value: "active",
      svg: petType === 'dog' ? Active : activeCat,
      desc: t("dailyWalks"),
      selectedSvg: petType === 'dog' ? activeSelected : activeSelectedCat,
    },
    {
      id: 3,
      title: t("veryActive"),
      value: "very_active",
      svg: petType === 'dog' ? VeryActive : veryActiveCat,
      desc: t("regularExercise"),
      selectedSvg: petType === 'dog' ? veryActiveSelected : veryActiveSelectedCat,
    },
  ];

  const petBodyType = [
    {
      id: 1,
      title: t("thin"),
      value: petType === 'dog' ? "thin" : "thinCat",
      svg: petType === 'dog' ? <Thin /> : <ThinCat />,
      selectedSvg: petType === 'dog' ? thinSelected : thinSelectedCat,
    },
    {
      id: 2,
      title: t("ideal"),
      value: petType === 'dog' ? "normal" : "normalCat",
      svg: petType === 'dog' ? <Normal /> : <NormalCat />,
      selectedSvg: petType === 'dog' ? normalSelected : normalSelectedCat,
    },
    {
      id: 3,
      title: t("overweight"),
      value: petType === 'dog' ? "fat" : "fatCat",
      svg: petType === 'dog' ? <Fat /> : <FatCat />,
      selectedSvg: petType === 'dog' ? fatSelected : fatSelectedCat,
    },
  ];

  const increasePetKg = () => {
    if (petInfo.kg < 100) {
      setPetInfo({ ...petInfo, kg: Number(petInfo.kg) + 1 });
    }
  };

  const decreasePetKg = () => {
    if (petInfo.kg > 0) {
      setPetInfo({
        ...petInfo,
        kg: Number(petInfo.kg) - 1,
      });
    }
  };

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        kg: petKg,
      });
    }
  }, [petKg]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        gr: petGr,
      });
    }
  }, [petGr]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        activity: activityLevel,
      });
    }
  }, [activityLevel]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        bodyType: bodyType,
      });
    }
  }, [bodyType]);

  useEffect(() => {
    petInfo.kg && petInfo.activity && petInfo.bodyType
      ? setIsComplete(true)
      : setIsComplete(false);
  }, [petInfo]);

  return (
    <div className=" flex flex-col justify-center max-w-2xl w-full mx-4 mb-6">
      <div className="mb-6 border-b-2 border-yellow-400 pb-4 pt-12">
        <div className="mx-6">
          <div className="block font-medium font-poppins text-lg text-yellow-600 text-center">
            {petType == 'dog' ? t("petWeight") : t("catPetWeight")}
          </div>
          <div className="flex justify-center items-center mt-1">
            <input
              placeholder="00"
              onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              onChange={(e) =>
                e.target.value < 63
                  ? setPetKg(Number(e.target.value))
                  : setPetKg(62)
              }
              value={petInfo.kg}
              className="m-2 text-yellow-400 placeholder-yellow-400 border-b-4 border-yellow-400 border-dotted w-12 text-center focus:outline-none"
            />
            <div className="flex flex-col m-2">
              <button
                onClick={increasePetKg}
                className="flex items-center justify-center w-6 h-6 border-2 border-lime-600 text-yellow-500 text-center"
              >
                +
              </button>
              <button
                onClick={decreasePetKg}
                className="flex items-center justify-center w-6 h-6 mt-1 border-2 border-lime-600 text-yellow-400 text-center"
              >
                -
              </button>
            </div>
            <div className="font-poppins text-xl text-yellow-600 my-auto">
              Kg
            </div>
            <input
              placeholder="00"
              onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              onChange={(e) =>
                e.target.value < 1000
                  ? petKg < 62
                    ? setPetGr(Number(e.target.value))
                    : setPetGr(0)
                  : setPetGr(999)
              }
              value={petInfo.gr}
              className="m-2 ml-2 text-yellow-400 placeholder-yellow-400 border-b-4 border-yellow-400 border-dotted w-12 text-center focus:outline-none"
            />
            <div className="font-poppins text-xl text-yellow-600 my-auto">
              Gr
            </div>
          </div>

          {/* <Listbox value={petKg} onChange={setPetKg}>
            {({ open }) => (
              <>
                <Listbox.Label className="block font-medium font-poppins text-lg text-yellow-600 text-left">
                  Köpeğinizin ağırlığı
                </Listbox.Label>
                <div className="mt-1  relative">
                  <Listbox.Button className="bg-white w-full  relative border border-yellow-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-lime-500 focus:border-lime-500 sm:text-sm">
                    <span className="block truncate text-yellow-800">
                      {petInfo.kg ? `${petInfo.kg}` : "Bir yıl seçiniz..."}
                    </span>
                    <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                      <SelectorIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </span>
                  </Listbox.Button>

                  <Transition
                    show={open}
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                      {weightData.map((item, key) => (
                        <Listbox.Option
                          key={key}
                          className={({ active }) =>
                            classNames(
                              active
                                ? "text-white bg-lime-600"
                                : "text-yellow-800",
                              "cursor-default select-none relative py-2 pl-3 pr-9"
                            )
                          }
                          value={item.kg}
                        >
                          {({ petKg, active }) => (
                            <>
                              <span
                                className={classNames(
                                  petKg ? "font-semibold  " : "font-normal",
                                  "block truncate text-left "
                                )}
                              >
                                {item.kg}
                              </span>

                              {petKg ? (
                                <span
                                  className={classNames(
                                    active ? "text-white" : "text-lime-600",
                                    "absolute inset-y-0 right-0 flex items-center pr-4"
                                  )}
                                >
                                  <CheckIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </span>
                              ) : null}
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </div>
              </>
            )}
          </Listbox> */}
        </div>
      </div>

      <div className="mt-5 border-b-2 border-yellow-400 pb-4">
        <label className="text-lg font-poppins font-medium text-yellow-600">
          {petType == 'dog' ? t("petBodyShape"): t("catPetBodyShape")}
        </label>

        <fieldset className="mt-5">
          <div className="space-x-4 flex items-center justify-center sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
            {petBodyType.map((type) => (
              <div
                key={type.id}
                className="flex-col items-baseline justify-center relative"
                onClick={() => {
                  setBodyType(
                    type.value === petInfo.bodyType ? "" : type.value
                  );
                }}
              >
                <div className="flex justify-center relative h-12 w-16 mb-4 sm:h-16 sm:w-24">
                  {type.svg}
                  <img
                    className={`h-12 w-16 mb-4 absolute top-0 left-[3px] -z-10 sm:h-16 sm:w-24  ${
                      type.value == petInfo.bodyType ? "" : "hidden"
                    }`}
                    src={type.selectedSvg}
                    alt={type.title}
                  />
                </div>
                <button
                  type="button"
                  className={`inline-flex items-center px-2.5 py-1.5 border  shadow-sm text-xs font-medium rounded  
                  ${
                    type.value === petInfo.bodyType
                      ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                      : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50"
                  }`}
                >
                  {type.title}
                </button>
              </div>
            ))}
          </div>
        </fieldset>
      </div>
      <div className="mt-6">
        <label className="font-poppins text-lg font-medium text-yellow-600 ">
          {petType == 'dog' ? t("petActivity") : t("catPetActivity")}
        </label>

        <fieldset className="mt-4 ">
          <div className="space-x-2 flex items-center justify-around sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
            {petActivity.map((activity) => (
              <div
                key={activity.id}
                className="flex-col items-center justify-center w-full"
                onClick={() => {
                  setActivityLevel(
                    activity.value === petInfo.activity ? "" : activity.value
                  );
                }}
              >
                <div className="flex justify-center relative items-center ">
                  <img
                    className={`h-12 w-16 mb-4 sm:h-20 sm:w-24`}
                    src={activity.svg}
                    alt={activity.title}
                  />
                  <img
                    className={`h-12 w-16  absolute top-0 -mr-2 -z-10 sm:h-20 sm:w-24 ${
                      activity.value === petInfo.activity ? "" : "hidden"
                    }`}
                    src={activity.selectedSvg}
                    alt={activity.title}
                  />
                </div>

                <button
                  type="button"
                  className={`inline-flex items-center px-2.5 py-1.5 border  shadow-sm text-xs font-medium rounded  
                    ${
                      activity.value === petInfo.activity
                        ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                        : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50"
                    }`}
                >
                  {activity.title}
                </button>
                <div className="mt-2 text-xs text-yellow-400">
                  {activity.desc}
                </div>
              </div>
            ))}
          </div>
        </fieldset>
      </div>
    </div>
  );
}

export default PetBodyInfo;
